import React from "react";
import GAReactionDetailsContainer from "../../modules/GAReactions/containers/GAReactionDetailsContainer/GAReactionDetailsContainer";

const GAReactionDetails = () => {
  return <GAReactionDetailsContainer />;
};

export default GAReactionDetails;
